import {
  AlignmentType,
  Document,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  WidthType,
} from "docx";
import { CATEGORIES, ROLES, ZVANJA } from "../data/pravilnik";

const cell = (children, opts = {}) =>
  new TableCell({
    children,
    columnSpan: opts.span,
    shading: opts.fill ? { fill: opts.fill } : undefined,
    width: opts.width ? { size: opts.width, type: WidthType.PERCENTAGE } : undefined,
    margins: { top: 60, bottom: 60, left: 100, right: 100 },
  });

const p = (runs, opts = {}) =>
  new Paragraph({ children: runs, alignment: opts.align, spacing: { after: opts.after ?? 0 } });

const t = (text, opts = {}) =>
  new TextRun({
    text,
    bold: opts.bold,
    italics: opts.italics,
    highlight: opts.highlight,
    size: opts.size ?? 20,
    font: "Calibri",
  });

export async function exportDocx({ basic, target, counts, calc }) {
  const zvanje = ZVANJA[target];
  const role = ROLES.find((r) => r.id === basic.role);
  const rows = [];

  rows.push(
    new TableRow({
      children: [
        cell([p([t("ELEMENTI", { bold: true })])], { width: 82, fill: "E2E8F0" }),
        cell([p([t("BODOVI", { bold: true })], { align: AlignmentType.CENTER })], { width: 18, fill: "E2E8F0" }),
      ],
      tableHeader: true,
    })
  );

  CATEGORIES.forEach((cat) => {
    const entered = cat.items.filter((i) => (Number(counts[i.id]) || 0) > 0);
    if (entered.length === 0) return;

    rows.push(
      new TableRow({
        children: [cell([p([t(cat.title.toUpperCase(), { bold: true })])], { span: 2, fill: "DBEAFE" })],
      })
    );

    entered.forEach((item) => {
      const n = Number(counts[item.id]);
      const subtotal = n * item.points;
      rows.push(
        new TableRow({
          children: [
            cell([p([t(item.label, { bold: true, italics: true })])]),
            cell([p([t(`${n} × ${item.points} = ${subtotal}`, { bold: true })], { align: AlignmentType.CENTER })]),
          ],
        })
      );
      for (let i = 1; i <= n; i++) {
        rows.push(
          new TableRow({
            children: [
              cell([
                p([
                  t(`${i}. `),
                  t("[Upišite naziv/opis aktivnosti, datum i poveznicu na dokaz u OneDrive/Drive mapi]", {
                    italics: true,
                    highlight: "yellow",
                  }),
                ]),
              ]),
              cell([p([t(String(item.points))], { align: AlignmentType.CENTER })]),
            ],
          })
        );
      }
    });

    rows.push(
      new TableRow({
        children: [
          cell([p([t("Ukupno:", { bold: true })], { align: AlignmentType.RIGHT })], { fill: "F1F5F9" }),
          cell([p([t(String(calc.byCategory[cat.id]), { bold: true })], { align: AlignmentType.CENTER })], { fill: "F1F5F9" }),
        ],
      })
    );
  });

  rows.push(
    new TableRow({
      children: [
        cell([p([t("UKUPNO:", { bold: true, size: 22 })], { align: AlignmentType.RIGHT })], { fill: "DBEAFE" }),
        cell([p([t(String(calc.total), { bold: true, size: 22 })], { align: AlignmentType.CENTER })], { fill: "DBEAFE" }),
      ],
    })
  );

  const doc = new Document({
    sections: [
      {
        children: [
          p([t("TABLICA BODOVA ZA NAPREDOVANJE", { bold: true, size: 32 })], { after: 120 }),
          p([t("Ime i prezime: _______________________________", { size: 22 })], { after: 80 }),
          p([t("Školska ustanova: _______________________________", { size: 22 })], { after: 80 }),
          p([t(`Radno mjesto: ${role?.label || ""}`, { size: 22 })], { after: 80 }),
          p([t(`Zvanje za koje se podnosi zahtjev: ${zvanje.label}`, { size: 22 })], { after: 80 }),
          p([t(`Datum izrade: ${new Date().toLocaleDateString("hr-HR")}`, { size: 22 })], { after: 160 }),
          p(
            [
              t("UPUTA: ", { bold: true }),
              t(
                "Žuto označene retke zamijenite vlastitim podatcima: nazivom/opisom aktivnosti, datumom te poveznicom na dokaz u vašoj OneDrive/Google Drive mapi. Retke možete slobodno dodavati, uređivati ili brisati. Gotov dokument po želji spremite kao PDF.",
                { italics: true }
              ),
            ],
            { after: 200 }
          ),
          new Table({ rows, width: { size: 100, type: WidthType.PERCENTAGE } }),
          p([t("")], { after: 120 }),
          p(
            [
              t(
                "Tablica je izrađena pomoću aplikacije Kalkulator napredovanja prema Pravilniku o napredovanju (NN 68/2019 i 32/2021). Izračun je informativnog karaktera.",
                { italics: true, size: 16 }
              ),
            ],
            {}
          ),
        ],
      },
    ],
  });

  const blob = await Packer.toBlob(doc);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "tablica-bodova-napredovanje.docx";
  a.click();
  URL.revokeObjectURL(url);
}
